// extracted by mini-css-extract-plugin
module.exports = {"title":"tutorials_title__KDrj_","logo":"tutorials_logo__L5B8o","play":"tutorials_play__evc2C"};